/**
 * Перезагрузка Turbo-фрейма после изменения данных.
 *
 * `frame.reload()` опирается на `src`, а фреймы страниц отрисованы сервером
 * сразу и атрибута `src` не имеют — вызов просто ничего не делал, и карточка
 * оставалась со старыми числами до ручного обновления страницы. Первый раз
 * проставляем `src`: Turbo сам сходит за страницей и подменит содержимое.
 */
export function reloadFrame(id) {
  const frame = document.getElementById(id);

  if (!frame) {
    window.location.reload();
    return;
  }

  if (frame.src) frame.reload();
  else frame.src = window.location.href;
}
